export const uploadSummaryFields = {
  name: 'string',
  lastModified: 'date'
};



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-file-upload/src/summary/file-upload-summary.constants.js